/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.OnlinePresenceManagement {
    angular.module("meevo.plugins.onlinePresenceManagement", []);
}